import React from 'react';
import { Card, CardHeader, CardBody } from 'react-bootstrap';
import { ASSET_URL } from '../../../../helper/api_url';
import { formatDate } from '../../../../helper/formatDate';
import { openGoogleMap } from '../EnquiryList/enquiryUtils';
import ImageViewer from '../../../../components/ImageViewer';

export const SchoolProfileCard = ({ report }) => {
    if (!report) return null;

    const avatarUrl = ASSET_URL + report.avatar;
    const hasMapLocation = Boolean(report.feedback);

    return (
        <Card className="border-0 shadow-sm rounded-3">
            <CardHeader className="py-3 px-4 border-bottom bg-light-subtle d-flex align-items-center justify-content-between">
                <h5 className="card-title mb-0 fs-15 fw-bold text-dark">School Profile</h5>
                <span className="badge bg-soft-primary text-primary fs-11 px-2 py-0.5">
                    Profile Info
                </span>
            </CardHeader>
            <CardBody className="p-3 p-md-4">
                {/* School Avatar with Clickable Viewer */}
                <div className="text-center mb-3.5">
                    <ImageViewer image={avatarUrl}>
                        <div className="position-relative d-inline-block cursor-pointer" title="Click to view avatar">
                            <img
                                src={avatarUrl}
                                alt={report.name || 'School Profile'}
                                className="rounded-circle border shadow-sm"
                                style={{
                                    width: '95px',
                                    height: '95px',
                                    objectFit: 'cover'
                                }}
                            />
                            <span
                                className="position-absolute bottom-0 end-0 bg-primary text-white rounded-circle p-1 shadow-sm d-flex align-items-center justify-content-center"
                                style={{ width: '26px', height: '26px' }}
                                title="Expand image"
                            >
                                <i className="ri-zoom-in-line fs-13" />
                            </span>
                        </div>
                    </ImageViewer>
                    <h6 className="fs-15 fw-bold text-dark mt-2 mb-0.5">{report.name || 'School Name'}</h6>
                    <small className="text-muted fs-12">
                        {report.father_name ? `Principal: ${report.father_name}` : 'Principal details N/A'}
                    </small>
                </div>

                {/* Profile Details List */}
                <ul className="list-group list-group-flush fs-13">
                    <li className="list-group-item px-0 py-2.5 d-flex justify-content-between align-items-center">
                        <span className="text-muted fw-medium">Entry Date:</span>
                        <span className="fw-semibold text-dark">{formatDate(report.created_at)}</span>
                    </li>

                    <li className="list-group-item px-0 py-2.5 d-flex justify-content-between align-items-center">
                        <span className="text-muted fw-medium">Phone:</span>
                        <a href={`tel:${report.phone}`} className="fw-semibold text-success text-decoration-none">
                            <i className="bx bx-phone me-1" />
                            {report.phone || 'N/A'}
                        </a>
                    </li>

                    <li className="list-group-item px-0 py-2.5 d-flex justify-content-between align-items-center">
                        <span className="text-muted fw-medium">WhatsApp:</span>
                        {report.whatsapp ? (
                            <a
                                href={`https://wa.me/${report.whatsapp}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="fw-semibold text-success text-decoration-none"
                            >
                                <i className="ri-whatsapp-line me-1" />
                                {report.whatsapp}
                            </a>
                        ) : (
                            <span className="text-muted">N/A</span>
                        )}
                    </li>

                    <li className="list-group-item px-0 py-2.5 d-flex justify-content-between align-items-start">
                        <span className="text-muted fw-medium">Address:</span>
                        <span className="fw-medium text-dark text-end" style={{ maxWidth: '60%' }}>
                            {report.address_1 || report.address || 'N/A'}
                        </span>
                    </li>

                    <li className="list-group-item px-0 py-2.5 d-flex justify-content-between align-items-center">
                        <span className="text-muted fw-medium">District:</span>
                        <span className="fw-semibold text-dark">{report.district || 'N/A'}</span>
                    </li>

                    {/* Location replacing Feedback */}
                    <li className="list-group-item px-0 py-2.5 d-flex justify-content-between align-items-center">
                        <span className="text-muted fw-medium">
                            <i className="ri-map-pin-line text-danger me-1" />
                            Location:
                        </span>
                        {hasMapLocation ? (
                            <button
                                type="button"
                                onClick={() => openGoogleMap(report.feedback)}
                                className="btn btn-sm btn-soft-danger py-0.5 px-2 fs-12 d-inline-flex align-items-center gap-1"
                                title="Open location in Google Maps"
                            >
                                <i className="ri-map-pin-2-fill fs-13" />
                                <span>View on Map</span>
                            </button>
                        ) : (
                            <span className="text-muted fst-italic">No location link</span>
                        )}
                    </li>
                </ul>
            </CardBody>
        </Card>
    );
};

export default SchoolProfileCard;
